<template>
  <page-header-wrapper>
    <div class="dash" v-if="userInfo.adminFlag">
      <header class="dash-hero">
        <div class="dash-hero__copy">
          <p class="dash-hero__eyebrow">运营看板</p>
          <h1 class="dash-hero__title">{{ timeFix }}，{{ nickname || '管理员' }}</h1>
          <p class="dash-hero__desc">短剧业务核心指标一览，支持按今日 / 昨日 / 近七日切换</p>
        </div>
        <div class="dash-hero__glow" aria-hidden="true"></div>
      </header>

      <section class="dash-metrics">
        <article class="metric-card metric-card--summary">
          <div class="metric-card__head">
            <span class="metric-card__label">总览</span>
          </div>
          <div class="summary-grid">
            <div class="summary-item">
              <span class="summary-item__label">总用户数</span>
              <strong class="summary-item__value">{{ totalUserCount }}</strong>
            </div>
            <div class="summary-item">
              <span class="summary-item__label">会员用户总数</span>
              <strong class="summary-item__value">{{ totalVipCount }}</strong>
            </div>
            <div class="summary-item summary-item--accent">
              <span class="summary-item__label">充值总金额</span>
              <strong class="summary-item__value">${{ totalRechargeAmount }}</strong>
            </div>
          </div>
        </article>

        <article class="metric-card">
          <div class="metric-card__head">
            <span class="metric-card__label">{{ periodLabel(userFlag) }} · 新增用户数</span>
            <span class="metric-card__date">{{ periodDate(userFlag) }}</span>
          </div>
          <div class="metric-card__value">{{ userNum }}</div>
          <a-radio-group
            class="metric-switch"
            :value="userFlag"
            @change="(e) => updateUser(e.target.value)"
            button-style="solid"
            size="small"
          >
            <a-radio-button value="a">今日</a-radio-button>
            <a-radio-button value="b">昨日</a-radio-button>
            <a-radio-button value="c">近七日</a-radio-button>
          </a-radio-group>
        </article>

        <article class="metric-card">
          <div class="metric-card__head">
            <span class="metric-card__label">{{ periodLabel(diominFlag) }} · 累计充值金币收入</span>
            <span class="metric-card__date">{{ periodDate(diominFlag) }}</span>
          </div>
          <div class="metric-card__value metric-card__value--money">${{ totalNum }}</div>
          <a-radio-group
            class="metric-switch"
            :value="diominFlag"
            @change="(e) => updateDiomn(e.target.value)"
            button-style="solid"
            size="small"
          >
            <a-radio-button value="a">今日</a-radio-button>
            <a-radio-button value="b">昨日</a-radio-button>
            <a-radio-button value="c">近七日</a-radio-button>
          </a-radio-group>
        </article>

        <article class="metric-card">
          <div class="metric-card__head">
            <span class="metric-card__label">{{ periodLabel(vipFlag) }} · 累计购买会员收入</span>
            <span class="metric-card__date">{{ periodDate(vipFlag) }}</span>
          </div>
          <div class="metric-card__value metric-card__value--money">${{ manNum }}</div>
          <a-radio-group
            class="metric-switch"
            :value="vipFlag"
            @change="(e) => updateVip(e.target.value)"
            button-style="solid"
            size="small"
          >
            <a-radio-button value="a">今日</a-radio-button>
            <a-radio-button value="b">昨日</a-radio-button>
            <a-radio-button value="c">近七日</a-radio-button>
          </a-radio-group>
        </article>

        <article class="metric-card">
          <div class="metric-card__head">
            <span class="metric-card__label">{{ periodLabel(buyFlag) }} · 累计购买剧集收入</span>
            <span class="metric-card__date">{{ periodDate(buyFlag) }}</span>
          </div>
          <div class="metric-card__value">金币数：{{ dionNum }}</div>
          <a-radio-group
            class="metric-switch"
            :value="buyFlag"
            @change="(e) => updateBuy(e.target.value)"
            button-style="solid"
            size="small"
          >
            <a-radio-button value="a">今日</a-radio-button>
            <a-radio-button value="b">昨日</a-radio-button>
            <a-radio-button value="c">近七日</a-radio-button>
          </a-radio-group>
        </article>
      </section>

      <section class="dash-charts">
        <div class="chart-panel">
          <div id="myChart" class="chart-box"></div>
        </div>
        <div class="chart-panel">
          <div id="myChart4" class="chart-box"></div>
        </div>
        <div class="chart-panel">
          <div id="myChart1" class="chart-box chart-box--pie"></div>
        </div>
        <div class="chart-panel">
          <div id="myChart3" class="chart-box chart-box--pie"></div>
        </div>
      </section>
    </div>

    <div class="dash" v-else>
      <header class="dash-hero dash-hero--agent">
        <div class="dash-hero__copy">
          <p class="dash-hero__eyebrow">分销看板</p>
          <h1 class="dash-hero__title">{{ timeFix }}，{{ nickname || '用户' }}</h1>
          <p class="dash-hero__desc">下级用户与佣金表现，支持按今日 / 昨日 / 近七日切换</p>
        </div>
        <div class="dash-hero__glow" aria-hidden="true"></div>
      </header>

      <section class="dash-metrics dash-metrics--agent">
        <article class="metric-card">
          <div class="metric-card__head">
            <span class="metric-card__label">{{ periodLabel(DisUserFlag) }} · 新增下级用户数</span>
            <span class="metric-card__date">{{ periodDate(DisUserFlag) }}</span>
          </div>
          <div class="metric-card__value">{{ disUserNum }}</div>
          <a-radio-group
            class="metric-switch"
            :value="DisUserFlag"
            @change="(e) => updateDisUser(e.target.value)"
            button-style="solid"
            size="small"
          >
            <a-radio-button value="a">今日</a-radio-button>
            <a-radio-button value="b">昨日</a-radio-button>
            <a-radio-button value="c">近七日</a-radio-button>
          </a-radio-group>
        </article>

        <article class="metric-card">
          <div class="metric-card__head">
            <span class="metric-card__label">{{ periodLabel(disDiominFlag) }} · 累计佣金收入</span>
            <span class="metric-card__date">{{ periodDate(disDiominFlag) }}</span>
          </div>
          <div class="metric-card__value metric-card__value--money">${{ disTotalNum }}</div>
          <a-radio-group
            class="metric-switch"
            :value="disDiominFlag"
            @change="(e) => updateDisDiomn(e.target.value)"
            button-style="solid"
            size="small"
          >
            <a-radio-button value="a">今日</a-radio-button>
            <a-radio-button value="b">昨日</a-radio-button>
            <a-radio-button value="c">近七日</a-radio-button>
          </a-radio-group>
        </article>

        <article class="metric-card">
          <div class="metric-card__head">
            <span class="metric-card__label">{{ periodLabel(orderFlag) }} · 下级用户充值订单数</span>
            <span class="metric-card__date">{{ periodDate(orderFlag) }}</span>
          </div>
          <div class="metric-card__value">{{ orderNum }}单</div>
          <a-radio-group
            class="metric-switch"
            :value="orderFlag"
            @change="(e) => updateOrderDiomn(e.target.value)"
            button-style="solid"
            size="small"
          >
            <a-radio-button value="a">今日</a-radio-button>
            <a-radio-button value="b">昨日</a-radio-button>
            <a-radio-button value="c">近七日</a-radio-button>
          </a-radio-group>
        </article>

        <article class="metric-card">
          <div class="metric-card__head">
            <span class="metric-card__label">{{ periodLabel(rechargeFlag) }} · 下级用户充值金额</span>
            <span class="metric-card__date">{{ periodDate(rechargeFlag) }}</span>
          </div>
          <div class="metric-card__value metric-card__value--money">${{ rechargeNum }}</div>
          <a-radio-group
            class="metric-switch"
            :value="rechargeFlag"
            @change="(e) => updateRechargeDiomn(e.target.value)"
            button-style="solid"
            size="small"
          >
            <a-radio-button value="a">今日</a-radio-button>
            <a-radio-button value="b">昨日</a-radio-button>
            <a-radio-button value="c">近七日</a-radio-button>
          </a-radio-group>
        </article>
      </section>

      <section class="dash-charts">
        <div class="chart-panel">
          <div id="myChart5" class="chart-box"></div>
        </div>
        <div class="chart-panel">
          <div id="myChart6" class="chart-box"></div>
        </div>
        <template v-if="userInfo.roleList && userInfo.roleList[0] && userInfo.roleList[0].id != 16">
          <div class="chart-panel">
            <div id="myChart7" class="chart-box chart-box--pie"></div>
          </div>
          <div class="chart-panel">
            <div id="myChart8" class="chart-box chart-box--pie"></div>
          </div>
        </template>
      </section>
    </div>
  </page-header-wrapper>
</template>

<script>
import {timeFix} from '@/utils/util'
import {mapGetters} from 'vuex'
import {PageHeaderWrapper} from '@/components/ProLayout'
import ruoyiLogo from '@/assets/projects/ruoyi.png'
import antdvLogo from '@/assets/projects/antdv.png'
import * as echarts from 'echarts';
import {
  getInstutionByDay,
  getBuyVipData,
  getUserData,
  getRechargePal,
  getDisRechargePal,
  getALLCollectNum,
  getDiomnData,
  updateDisDiomn,
  updateOrderDiomn,
  updateRechargeDiomn,
  getVipData,
  getDisUserData,
  getRuioDataByDay,
  getDisInstutionByDay,
  getMoneyInstutionByDay,
  getMoneyRechargePal,
  getBuyData
} from '@/api/system/user'
import { getUserTotalData } from '@/api/biz/userForm'
import { getTopData ,getUserVipDatas} from '@/api/system/data'
import ChartCard from './ChartCard'
import moment from 'moment';
import {getSmsTotalBarChart, getSmsTotalPieChart} from "@/api/sms/log";

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper,
    ChartCard
  },
  data() {
    return {
      xInstutiondata: [],
      yInstutiondata1: [],

      xInstutiondata1s: [],
      yInstutiondata1s: [],

      xInstutiondata4: [],
      yInstutiondata4: [],
      yInstutiondata4s: [],


      yInstutiondata2: [],
      userFlag: 'a',
      DisUserFlag: 'a',
      diominFlag: 'a',
      orderFlag: 'a',
      rechargeFlag: 'a',
      disDiominFlag: 'a',
      vipFlag: 'a',
      disVipFlag: 'a',
      buyFlag: 'a',
      DisbuyFlag: 'a',
      xStroredata: [],
      yStroredata1: [],
      yStroredata2: [],

      xUserdata: [],
      yUserdata1: [],
      yUserdata2: [],
      rechargeData: [],
      disRechargeData: [],
      moneyRechargeData: [],

      xdevicedata: [],
      ydevicedata1: [],
      ydevicedata2: [],

      userDayOneData: [],
      userDayTwoData: [],

      xDisInstutiondata:[],
      yDisInstutiondata1:[],

      xMoneyInstutiondata:[],
      yMoneyInstutiondata1:[],
      totalNum: "0",
      disTotalNum: "0",
      orderNum: "0",
      rechargeNum: "0",
      userNum: "0",
      disUserNum: "0",
      noNum: "0",
      manNum: "0",
      womanNum: "0",
      dionNum: "0",
      // 新增卡片数据
      totalUserCount: "0",
      totalVipCount: "0",
      totalRechargeAmount: "0",
      instutionList: [],
      storeList: [],
      loading: false,
      // 贡献者
      contributors: [
        {
          name: 'wangze',
          avatar: 'https://portrait.gitee.com/uploads/avatars/user/1662/4988475_fuzui_1586973704.png!avatar60',
          email: '73400@163.com'
        }
      ],
      // 赞助
      sponsorList: [
        {
          key: 'RuoYi',
          tab: 'RuoYi'
        },
        {
          key: 'Antdv',
          tab: 'Antdv'
        }
      ],
      noTitleKey: 'RuoYi',
      timeFix: timeFix(),
      // 用户信息
      user: {
        dept: {
          deptName: ''
        }
      },
      roleGroup: {},
      postGroup: {},
      // 致谢项目
      projects: [
        {
          logo: ruoyiLogo,
          name: 'RuoYi-Vue',
          description: '基于SpringBoot，Spring Security，JWT，Vue & Element 的前后端分离权限管理系统。',
          website: 'http://ruoyi.vip',
          downloadUrl: 'https://gitee.com/y_project/RuoYi-Vue'
        },
        {
          logo: antdvLogo,
          name: 'Ant Design Vue',
          description: 'An enterprise-class UI components based on Ant Design and Vue. ',
          website: 'https://antdv.com',
          downloadUrl: 'https://github.com/vueComponent/ant-design-vue/'
        },
        {
          logo: antdvLogo,
          name: 'Antd Pro Vue',
          description: 'An out-of-box UI solution for enterprise applications as a Vue boilerplate. based on Ant Design of Vue.',
          website: 'https://pro.antdv.com',
          downloadUrl: 'https://github.com/vueComponent/ant-design-vue/'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'nickname',
      'userInfo'
    ])
  },
  created() {
    // this.getUser()
    // if (!this.userInfo.adminFlag) {
    this.updateUser('a')
    this.updateDiomn('a')
    this.updateDisDiomn('a')
    this.updateOrderDiomn('a')
    this.updateRechargeDiomn('a')
    this.updateVip('a')
    this.updateBuy('a')
    // }

    this.drawLine1()
    this.getTotalStatistics()

    // this.getALLCollection()
  },
  mounted() {
    this.drawLine1()
    this.drawLine2()
    this.drawLine3()
    this.drawLine4()
    if (!this.userInfo.adminFlag) {
      this.drawLine5()
      this.drawLine6()
      this.drawLine7()
      this.drawLine8()
      this.updateDisDiomn('a')
      this.updateOrderDiomn('a')
      this.updateRechargeDiomn('a')
      this.updateDisUser('a')
    }
    this.updateUser('a')
    this.updateDiomn('a')
    this.updateVip('a')
    this.updateBuy('a')
    window.addEventListener('resize', this.handleChartResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleChartResize)
    if (this._chartMap) {
      Object.keys(this._chartMap).forEach(key => {
        const chart = this._chartMap[key]
        if (chart) chart.dispose()
      })
      this._chartMap = null
    }
  },
  methods: {
    periodLabel(flag) {
      if (flag === 'b') return '昨日'
      if (flag === 'c') return '近七日'
      return '今日'
    },
    periodDate(flag) {
      if (flag === 'b') return this.data(2)
      if (flag === 'c') return this.data(3)
      return this.data(1)
    },
    initOrUpdateChart(id, option) {
      const el = document.getElementById(id)
      if (!el) return
      if (!this._chartMap) this._chartMap = {}
      let chart = this._chartMap[id] || echarts.getInstanceByDom(el)
      if (!chart) {
        chart = echarts.init(el)
      }
      this._chartMap[id] = chart
      chart.setOption(option, true)
      this.$nextTick(() => chart.resize())
    },
    handleChartResize() {
      if (!this._chartMap) return
      Object.keys(this._chartMap).forEach(key => {
        const chart = this._chartMap[key]
        if (chart) chart.resize()
      })
    },
    updateUser(value) {
      console.log(value)
      this.userFlag = value
      getUserData({
        type: value
      }).then(res => {
        const data = res.data;
        this.userNum = data + "";
      });
    },
    updateDisUser(value) {
      console.log(value)
      this.DisUserFlag = value
      getDisUserData({
        type: value
      }).then(res => {
        const data = res.data;
        this.disUserNum = data + "";
      });
    },
    updateDiomn(value) {
      this.diominFlag = value
      getDiomnData({
        type: value
      }).then(res => {
        const data = res.data;
        this.totalNum = data + "";
      });
    },


    updateDisDiomn(value) {
      this.disDiominFlag = value
      updateDisDiomn({
        type: value
      }).then(res => {
        const data = res.data;
        this.disTotalNum = data + "";
      });
    },


    updateOrderDiomn(value) {
      this.orderFlag = value
      updateOrderDiomn({
        type: value
      }).then(res => {
        const data = res.data;
        this.orderNum = data + "";
      });
    },

    updateRechargeDiomn(value) {
      this.rechargeFlag = value
      updateRechargeDiomn({
        type: value
      }).then(res => {
        const data = res.data;
        this.rechargeNum = data + "";
      });
    },

    updateVip(value) {
      this.vipFlag = value
      getVipData({
        type: value
      }).then(res => {
        const data = res.data;
        this.manNum = data + "";
      });
    },
    updateBuy(value) {
      this.buyFlag = value
      getBuyData({
        type: value
      }).then(res => {
        const data = res.data;

        data.forEach((el) => {
          if (el.type == '1') {
            this.womanNum = el.price + "";
          }
          if (el.type == '2') {
            this.dionNum = el.price + "";
          }
        });
      });
    },
    /** 获取总统计数据（总用户量、会员用户总数、充值总金额） */
    getTotalStatistics() {
      // 获取用户统计数据
      getUserVipDatas().then(response => {
        if (response.data) {
          const data = response.data
          // 总用户量
          this.totalUserCount = (data.totalUserCount || 0) + ""
          // 会员用户总数
          this.totalVipCount = (data.totalVipCount || 0) + ""
          this.totalRechargeAmount = (data.totalRechargeAmount || 0) + ""
        }
      }).catch(error => {
        console.error('获取用户统计数据失败:', error)
      })

      // // 获取充值总金额（从 getTopData 获取）
      // getTopData({ selectData: null, searchTime: null }).then(response => {
      //   if (response.data) {
      //     const data = response.data
      //     // 充值总金额（根据实际返回的字段调整）
      //     // 如果 getTopData 返回的数据中有充值总金额字段，使用它
      //     // 否则可能需要从其他字段计算或使用其他API
      //     this.totalRechargeAmount = (data.totalRechargeAmount || data.totalRecharge || data.rechargeTotal || 0) + ""
      //   }
      // }).catch(error => {
      //   console.error('获取充值总金额失败:', error)
      // })
    },
    // 获取用户信息
    getUser() {
      getUserProfile().then(response => {
        this.user = response.data
        this.roleGroup = response.roleGroup
        this.postGroup = response.postGroup
      })
    },
    data(value) {
      if (value === 1) {
        var today = new Date();
        var year = today.getFullYear();//获取年份
        var month = today.getMonth() + 1;//获取月份
        var day = today.getDate();//获取日期
        return year + "-" + month + "-" + day + '~' + year + "-" + month + "-" + day
      }
      if (value === 2) {
        var today = new Date();
        var yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
        return yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1) + "-" + yesterday.getDate() + '~' + yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1) + "-" + yesterday.getDate()
      }

      if (value === 3) {
        var today = new Date();
        var yesterday = new Date(today.getTime() - 144 * 60 * 60 * 1000);
        var yesterdays = new Date(today.getTime());
        return yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1) + "-" + yesterday.getDate() + '~' + yesterdays.getFullYear() + "-" + (yesterdays.getMonth() + 1) + "-" + yesterdays.getDate()
      }
    },


    onSponsorTabChange(key, type) {
      this[type] = key
    },
    collectionCount() {
      getInstutionByDay().then(res => {
        if (res.data) {
          const data = res.data;
          data.forEach((el) => {
            const obj = {}
            obj.num = el.price;
            obj.title = el.times;
            this.instutionList.push(obj);
          });
        }
      });
      // /*门店日增*/
      // getStoreByDay().then(res => {
      //   if (res.data){
      //     const data = res.data;
      //     data.forEach((el) => {
      //       const obj = {}
      //       obj.num = el.num;
      //       obj.title = el.time;
      //       this.storeList.push(obj);
      //     });
      //   }
      // });
    },
    getALLCollection() {
      //统计（机构总数量、门店总数量、用户总数量、设备总数量）
      getALLCollectNum().then(res => {
        if (res.data) {
          const data = res.data;
          this.totalNum = data.totalNum + "";
          this.userNum = data.userNum + "";
          this.noNum = data.noNum + "";
          this.manNum = data.manNum + "";
          this.womanNum = data.womanNum + "";
        }
      });
    },

    drawLine1() {
      //获取机构概览
      getInstutionByDay().then(res => {
        this.xInstutiondata = [];
        this.yInstutiondata1 = [];
        this.xInstutiondata1s = [];
        this.yInstutiondata1s = [];
        if (res.data) {
          const data = res.data.orderNum;//  订单量
          data.forEach((el) => {
            this.xInstutiondata.push(el.times);
            this.yInstutiondata1.push(Number(el.nums));
          });
          res.data.orderMoney.forEach((el) => {
            // this.xInstutiondata1s.push(el.times);
            this.yInstutiondata1s.push(Number(el.moneys));
          });
          // debugger
          // console.log(this.xInstutiondata)
          // data1.forEach((el) => {
          //   this.yInstutiondata2.push(Number(el.num));
          // });

          var option = {
            color: ['#1A6B7A', '#E8A838'],
            title: {
              text: '用户充值概览',
              left: 12,
              top: 8,
              textStyle: { fontSize: 15, fontWeight: 600, color: '#132033' }
            },
            tooltip: {
              trigger: 'axis',
              triggerOn: 'mousemove'
            },
            legend: {
              data: ['充值收入', '充值订单数'],
              top: 10,
              right: 16
            },
            grid: {
              left: '3%',
              right: '6%',
              bottom: '3%',
              top: 56,
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xInstutiondata
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '充值订单数',
                type: 'line',
                smooth: true,
                data: this.yInstutiondata1
              },
              {
                name: '充值收入',
                type: 'line',
                smooth: true,
                data: this.yInstutiondata1s
              }
            ]
          }
          option && this.initOrUpdateChart('myChart', option)
        }
      });

    },


    drawLine5() {
      //获取机构概览
      getDisInstutionByDay().then(res => {
        this.xDisInstutiondata = [];
        this.yDisInstutiondata = [];
        if (res.data) {
          const data = res.data;//
          data.forEach((el) => {
            this.xDisInstutiondata.push(el.times);
            this.yDisInstutiondata.push(Number(el.nums));
          });

          // debugger
          // console.log(this.xInstutiondata)
          // data1.forEach((el) => {
          //   this.yInstutiondata2.push(Number(el.num));
          // });

          var option = {
            color: ['#1A6B7A'],
            title: {
              text: '下级用户充值概览',
              left: 12,
              top: 8,
              textStyle: { fontSize: 15, fontWeight: 600, color: '#132033' }
            },
            tooltip: {
              trigger: 'axis',
              triggerOn: 'mousemove'
            },
            legend: {
              data: ['下级用户充值金额'],
              top: 10,
              right: 16
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top: 56,
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xDisInstutiondata
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '充值订单数',
                type: 'line',
                smooth: true,
                data: this.yDisInstutiondata
              }
            ]
          }
          option && this.initOrUpdateChart('myChart5', option)
        }
      });

    },


    drawLine6() {
      //获取机构概览
      getMoneyInstutionByDay().then(res => {
        this.xMoneyInstutiondata = [];
        this.yMoneyInstutiondata = [];
        if (res.data) {
          const data = res.data;//
          data.forEach((el) => {
            this.xMoneyInstutiondata.push(el.times);
            this.yMoneyInstutiondata.push(Number(el.nums));
          });

          // debugger
          // console.log(this.xInstutiondata)
          // data1.forEach((el) => {
          //   this.yInstutiondata2.push(Number(el.num));
          // });

          var option = {
            color: ['#E85D4C'],
            title: {
              text: '佣金收入概览',
              left: 12,
              top: 8,
              textStyle: { fontSize: 15, fontWeight: 600, color: '#132033' }
            },
            tooltip: {
              trigger: 'axis',
              triggerOn: 'mousemove'
            },
            legend: {
              data: ['佣金收入概览'],
              top: 10,
              right: 16
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top: 56,
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xMoneyInstutiondata
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '佣金收入',
                type: 'line',
                smooth: true,
                data: this.yMoneyInstutiondata
              }
            ]
          }
          option && this.initOrUpdateChart('myChart6', option)
        }
      });

    },

    drawLine2() {
      getRuioDataByDay().then(res => {
        this.dataList = [];
        if (res.data) {
          this.dataList = res.data;//  每日总量
          var option = {
            color: ['#1A6B7A', '#E8A838', '#E85D4C', '#4F7CAC', '#7C6A9A'],
            title: {
              text: '数据分布',
              left: 12,
              top: 8,
              textStyle: { fontSize: 15, fontWeight: 600, color: '#132033' }
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '12%',
              left: 'center'
            },
            series: [
              {
                name: '数据值',
                type: 'pie',
                radius: ['40%', '68%'],
                center: ['50%', '58%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: true,
                  position: 'inner',
                  formatter: '{c}'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: true
                },
                data: this.dataList
              }
            ]
          }
          option && this.initOrUpdateChart('myChart1', option)
        }
      });
    },
    drawLine3() {
      getRechargePal().then(res => {
        this.rechargeData = [];
        if (res.data) {
          this.rechargeData = res.data;//  每日总量
          var option = {
            color: ['#1A6B7A', '#E8A838', '#E85D4C', '#4F7CAC', '#7C6A9A'],
            title: {
              text: '充值分布',
              left: 12,
              top: 8,
              textStyle: { fontSize: 15, fontWeight: 600, color: '#132033' }
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '12%',
              left: 'center'
            },
            series: [
              {
                name: '充值数',
                type: 'pie',
                radius: ['40%', '68%'],
                center: ['50%', '58%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: true,
                  position: 'inner',
                  formatter: '{c}'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.rechargeData
              }
            ]
          }
          option && this.initOrUpdateChart('myChart3', option)
        }
      });
    },


    drawLine7() {
      getDisRechargePal().then(res => {
        this.disRechargeData = [];
        if (res.data) {
          this.disRechargeData = res.data;//  每日总量
          var option = {
            color: ['#1A6B7A', '#E8A838', '#E85D4C', '#4F7CAC', '#7C6A9A'],
            title: {
              text: '下级充值分布',
              left: 12,
              top: 8,
              textStyle: { fontSize: 15, fontWeight: 600, color: '#132033' }
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '12%',
              left: 'center'
            },
            series: [
              {
                name: '人数',
                type: 'pie',
                radius: ['40%', '68%'],
                center: ['50%', '58%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.disRechargeData
              }
            ]
          }
          option && this.initOrUpdateChart('myChart7', option)
        }
      });
    },


    drawLine8() {
      getMoneyRechargePal().then(res => {
        this.moneyRechargeData = [];
        if (res.data) {
          this.moneyRechargeData = res.data;//  每日总量
          var option = {
            color: ['#1A6B7A', '#E8A838', '#E85D4C', '#4F7CAC', '#7C6A9A'],
            title: {
              text: '佣金分布',
              left: 12,
              top: 8,
              textStyle: { fontSize: 15, fontWeight: 600, color: '#132033' }
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '12%',
              left: 'center'
            },
            series: [
              {
                name: '人数',
                type: 'pie',
                radius: ['40%', '68%'],
                center: ['50%', '58%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.moneyRechargeData
              }
            ]
          }
          option && this.initOrUpdateChart('myChart8', option)
        }
      });
    },




    drawLine4() {
      //获取机构概览
      getBuyVipData().then(res => {
        this.xInstutiondata4 = [];
        this.yInstutiondata4 = [];
        this.yInstutiondata4s = [];
        if (res.data) {
          const data = res.data.orderNum;//  订单量
          data.forEach((el) => {
            this.xInstutiondata4.push(el.times);
            this.yInstutiondata4.push(Number(el.nums));
          });
          res.data.orderMoney.forEach((el) => {
            // this.xInstutiondata4.push(el.times);
            this.yInstutiondata4s.push(Number(el.moneys));
          });
          var option = {
            color: ['#E85D4C', '#1A6B7A'],
            title: {
              text: '会员订阅概览',
              left: 12,
              top: 8,
              textStyle: { fontSize: 15, fontWeight: 600, color: '#132033' }
            },
            tooltip: {
              trigger: 'axis',
              triggerOn: 'mousemove'
            },
            legend: {
              data: ['订阅收入', '订阅数'],
              top: 10,
              right: 16
            },
            grid: {
              left: '3%',
              right: '7%',
              bottom: '3%',
              top: 56,
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xInstutiondata4
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '订阅数',
                type: 'line',
                smooth: true,
                data: this.yInstutiondata4
              },
              {
                name: '订阅收入',
                type: 'line',
                smooth: true,
                data: this.yInstutiondata4s
              }
            ]
          }
          option && this.initOrUpdateChart('myChart4', option)
        }
      });
    }

  },
}
</script>

<style lang="less" scoped>
@import "./index.less";

.dash {
  --dash-ink: #0f2a33;
  --dash-muted: #5a7480;
  --dash-line: rgba(14, 76, 92, 0.12);
  --dash-surface: linear-gradient(165deg, #f3fafb 0%, #e4f1f4 100%);
  --dash-teal: #0e7c86;
  --dash-coral: #d96a4a;
  --dash-gold: #d4a017;
  --dash-bg: #cfdfe6;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', sans-serif;
  width: 100%;
  min-height: 100%;
  padding: 8px 8px 28px;
  box-sizing: border-box;
  background:
    radial-gradient(900px 320px at 0% 0%, rgba(14, 124, 134, 0.22), transparent 58%),
    radial-gradient(780px 280px at 100% 8%, rgba(212, 160, 23, 0.16), transparent 55%),
    radial-gradient(640px 360px at 70% 100%, rgba(217, 106, 74, 0.12), transparent 50%),
    linear-gradient(160deg, #d5e6ed 0%, #c5d8e0 45%, #dce8ee 100%);
  border-radius: 14px;
}

.dash-hero {
  position: relative;
  overflow: hidden;
  margin-bottom: 18px;
  padding: 24px 26px;
  border-radius: 16px;
  background:
    linear-gradient(120deg, rgba(255, 255, 255, 0.08), transparent 40%),
    linear-gradient(135deg, #0b3a44 0%, #0e7c86 48%, #1f6f7a 100%);
  color: #fff;
  box-shadow: 0 14px 32px rgba(11, 58, 68, 0.22);
  animation: dashFadeUp 0.45s ease both;

  &--agent {
    background:
      linear-gradient(120deg, rgba(255, 255, 255, 0.08), transparent 40%),
      linear-gradient(135deg, #3a1f1a 0%, #a04935 48%, #c56b3d 100%);
  }

  &__copy {
    position: relative;
    z-index: 1;
    max-width: 720px;
  }

  &__eyebrow {
    margin: 0 0 6px;
    font-size: 12px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    opacity: 0.78;
  }

  &__title {
    margin: 0 0 8px;
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', sans-serif;
    font-size: clamp(22px, 2.4vw, 30px);
    font-weight: 700;
    line-height: 1.25;
  }

  &__desc {
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
    opacity: 0.9;
  }

  &__glow {
    position: absolute;
    right: -30px;
    top: -60px;
    width: 260px;
    height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 220, 140, 0.28), transparent 68%);
    pointer-events: none;
  }
}

.dash-metrics {
  display: grid;
  grid-template-columns: minmax(240px, 1.35fr) repeat(4, minmax(180px, 1fr));
  gap: 14px;
  margin-bottom: 16px;

  &--agent {
    grid-template-columns: repeat(4, minmax(180px, 1fr));
  }
}

.metric-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 168px;
  padding: 16px 16px 14px;
  border-radius: 16px;
  background: var(--dash-surface);
  border: 1px solid rgba(14, 124, 134, 0.14);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.65) inset,
    0 10px 22px rgba(15, 42, 51, 0.08);
  backdrop-filter: blur(6px);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  animation: dashFadeUp 0.5s ease both;

  &:nth-child(2) {
    animation-delay: 0.04s;
    background: linear-gradient(165deg, #f2f9fb 0%, #dcedf2 100%);
  }

  &:nth-child(3) {
    animation-delay: 0.08s;
    background: linear-gradient(165deg, #fff9ef 0%, #f3ead2 100%);

    &::before {
      background: var(--dash-gold);
    }
  }

  &:nth-child(4) {
    animation-delay: 0.12s;
    background: linear-gradient(165deg, #fff5f1 0%, #f2ddd4 100%);

    &::before {
      background: var(--dash-coral);
    }
  }

  &:nth-child(5) {
    animation-delay: 0.16s;
    background: linear-gradient(165deg, #f4f7ff 0%, #dde6f5 100%);

    &::before {
      background: #4f7cac;
    }
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow:
      0 1px 0 rgba(255, 255, 255, 0.7) inset,
      0 14px 28px rgba(15, 42, 51, 0.12);
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 14px;
    bottom: 14px;
    width: 3px;
    border-radius: 3px;
    background: var(--dash-teal);
  }

  &--summary {
    background:
      linear-gradient(145deg, rgba(14, 124, 134, 0.14), rgba(14, 124, 134, 0.02) 42%),
      linear-gradient(165deg, #e9f6f8 0%, #d2e9ee 100%);

    &::before {
      background: linear-gradient(180deg, var(--dash-teal), var(--dash-gold));
    }
  }

  &__head {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;
    padding-left: 8px;
  }

  &__label {
    color: var(--dash-ink);
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
  }

  &__date {
    color: var(--dash-muted);
    font-size: 12px;
    line-height: 1.3;
    word-break: break-all;
  }

  &__value {
    flex: 1;
    padding-left: 8px;
    margin-bottom: 12px;
    color: var(--dash-ink);
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', sans-serif;
    font-size: clamp(24px, 2.2vw, 32px);
    font-weight: 700;
    line-height: 1.2;
    word-break: break-all;

    &--money {
      color: #9a5b12;
    }
  }
}

.summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding-left: 8px;
  margin-top: auto;
}

.summary-item {
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(14, 124, 134, 0.1);

  &--accent {
    grid-column: 1 / -1;
    background: linear-gradient(100deg, rgba(212, 160, 23, 0.22), rgba(217, 106, 74, 0.12));
    border-color: rgba(212, 160, 23, 0.22);
  }

  &__label {
    display: block;
    margin-bottom: 4px;
    color: var(--dash-muted);
    font-size: 12px;
  }

  &__value {
    display: block;
    color: var(--dash-ink);
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
  }
}

.metric-switch {
  align-self: flex-start;
  margin-left: 8px;

  :deep(.ant-radio-button-wrapper) {
    height: 28px;
    line-height: 26px;
    padding: 0 10px;
    font-size: 12px;
    background: rgba(255, 255, 255, 0.45);
    border-color: rgba(14, 124, 134, 0.18);
    color: var(--dash-ink);
  }

  :deep(.ant-radio-button-wrapper:not(:first-child)::before) {
    background-color: rgba(14, 124, 134, 0.18);
  }

  :deep(.ant-radio-button-wrapper-checked) {
    background: var(--dash-teal);
    border-color: var(--dash-teal);
    color: #fff;
    box-shadow: -1px 0 0 0 var(--dash-teal);
  }

  :deep(.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover) {
    background: #0a6870;
    border-color: #0a6870;
    color: #fff;
  }
}

.dash-charts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.chart-panel {
  min-width: 0;
  padding: 10px;
  border-radius: 16px;
  background:
    linear-gradient(165deg, rgba(255, 255, 255, 0.55), rgba(228, 241, 244, 0.92));
  border: 1px solid rgba(14, 124, 134, 0.14);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.65) inset,
    0 10px 22px rgba(15, 42, 51, 0.08);
  animation: dashFadeUp 0.55s ease both;
}

.chart-box {
  width: 100%;
  height: clamp(260px, 36vw, 340px);

  &--pie {
    height: clamp(280px, 38vw, 360px);
  }
}

@keyframes dashFadeUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .dash-hero,
  .metric-card,
  .chart-panel {
    animation: none;
  }

  .metric-card:hover {
    transform: none;
  }
}

@media (max-width: 1400px) {
  .dash-metrics {
    grid-template-columns: repeat(3, minmax(0, 1fr));

    .metric-card--summary {
      grid-column: 1 / -1;
    }
  }
}

@media (max-width: 1100px) {
  .dash-metrics,
  .dash-metrics--agent {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .dash-charts {
    grid-template-columns: 1fr;
  }

  .chart-box,
  .chart-box--pie {
    height: 300px;
  }
}

@media (max-width: 640px) {
  .dash {
    padding: 0 0 16px;
  }

  .dash-hero {
    padding: 18px 16px;
    margin-bottom: 12px;
  }

  .dash-metrics,
  .dash-metrics--agent {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .metric-card {
    min-height: 148px;
  }

  .metric-switch {
    width: 100%;
    margin-left: 0;
    padding-left: 8px;

    :deep(.ant-radio-group),
    :deep(.ant-radio-button-wrapper) {
      flex: 1;
      text-align: center;
    }
  }

  .metric-switch {
    display: flex;

    :deep(.ant-radio-button-wrapper) {
      flex: 1;
      text-align: center;
      padding: 0 4px;
    }
  }
}
</style>
